import { Link } from 'react-router-dom';
import { postListFetcher } from '@/shared/api/list';
import { formatUnixDateTime } from '@/shared/lib/datetime';
import { DeleteButton } from '@/shared/ui/list/DeleteButton';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { deleteAiQuery } from './api';

const LIST_KEY = 'ai-queries';

interface AiQuery extends ListRow {
  id: number;
  create_time?: number;
  message_from_user?: string;
  additional_queries?: Array<{ query: string }>;
  car?: {
    name_mark?: string;
    name_model?: string;
    name_generation?: string;
    name_modification?: string;
  } | null;
  service_catalog?: Array<{ title: string }>;
  sum_services_labor_hours?: number | string;
}

const Lines = ({ items = [] }: { items?: string[] }) => (
  <>
    {items.map((item) => (
      <div key={item}>{item}</div>
    ))}
  </>
);

const config: ListPageConfig<AiQuery> = {
  queryKey: LIST_KEY,
  title: 'Запросы AI',
  boxTitle: 'Список запросов',
  errorText: 'Ошибка загрузки запросов AI',
  fetchList: postListFetcher('/ai/request-cache/list/'),
  rows: ['items'],
  columns: [
    { header: 'id', render: (item) => <Link to={`/stat/ai-queries/${item.id}`}>{item.id}</Link> },
    { header: 'Дата создания запроса', render: (item) => formatUnixDateTime(item.create_time) },
    { header: 'Запрос', render: (item) => item.message_from_user },
    {
      header: 'Варианты запроса',
      render: (item) => <Lines items={item.additional_queries?.map((q) => q.query)} />,
    },
    { header: 'Марка автомобиля', render: (item) => item.car?.name_mark },
    { header: 'Модель автомобиля', render: (item) => item.car?.name_model },
    { header: 'Поколение автомобиля', render: (item) => item.car?.name_generation },
    { header: 'Модификация автомобиля', render: (item) => item.car?.name_modification },
    {
      header: 'Услуги',
      render: (item) => <Lines items={item.service_catalog?.map((service) => service.title)} />,
    },
    { header: 'Нормочасы на услуги', render: (item) => item.sum_services_labor_hours },
    {
      header: 'Удалить',
      render: (item) => (
        <DeleteButton listKey={LIST_KEY} label="×" remove={() => deleteAiQuery(item.id)} />
      ),
    },
  ],
};

export const AIQueriesPage = () => <GenericListPage config={config} />;
